module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ceY5d"))).then(() => parcelRequire('1iHdE'));